import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    dialog: false,
    loading: false,
    videos: [],
    manual_claims:[],
    active: [],
    order_column: 'video_title',
    order_type: 'asc',
    page: 1,
    page_size: 10,
    filter: {},
    manual_filter: {},
    channels: [],
    manual_labels: [],
    last_updated:'',
  },

  mutations: {
    setVideos(state, payload) {
      state.videos = payload
    },
    setManualClaims(state, payload) {
      state.manual_claims = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    },
    setChannels(state, payload) {
      state.channels = payload
    },
    setFilter(state, payload) {
      state.filter = payload
    },
    setSyncResponse(state, payload) {
      state.sync_response = payload
    },
    setLastSync(state, payload){
      state.last_updated = payload
    },
    setManualLabels(state, payload) {
      state.manual_labels = payload
    },
    setManualFilter(state, payload) {
      state.manual_filter = payload
    },
  },

  actions: {
    readVideos({ commit, state }) {
      commit('setLoading', true)
      axios.admin
          .get('cms/youtube/channel/videos', {
              params: {
                  page: state.page,
                  page_size: state.page_size,
                  order_column: state.order_column,
                  order_type: state.order_type,
                  ...state.filter
              }
          })
          .then(r => {
            commit('setVideos', r.data.videos)
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
    readChannels({ commit }) {
      axios.admin
          .get('cms/youtube/channels')
          .then(r => {
              commit('setChannels', r.data.channels)
          })
    },
    readManualClaims({ commit, state }) {
        commit('setLoading', true)
        axios.admin
            .get('cms/youtube/channel/manual-claims', {
                params: {
                    page: state.page,
                    page_size: state.page_size,
                    order_column: 'id',
                    order_type: state.order_type,
                    ...state.manual_filter
                }
            })
            .then(r => {
                commit('setManualClaims', r.data.videos)
                commit('setLastSync', r.data.last_updated)
                commit('setManualLabels', r.data.label_names)
                commit('setLoading', false)
            })
            .catch(() => {
                commit('setLoading', false)
            })
    },
    async rejectClaim({ commit, dispatch }, { videoId, reason }) {
      commit('setLoading', true);
      try {
          const response = await axios.admin.post(
              'cms/youtube/channel/manual-claims/reject',
              {
                  videoId,
                  reason
              }
          );
          commit('setLoading', false);
          commit('setSuccessMessage', 'Claim rejected successfully');

          // Optionally refresh the claims list
          dispatch('readManualClaims');

          return response.data;
      } catch (error) {
          commit('setLoading', false);
          //commit('setErrorMessage', error.response?.data?.message || 'Failed to reject claim');
          throw error;
      }
    },
    syncClaims({ dispatch, commit }) {
      commit('setLoading', true)
      axios.admin
          .get('cms/youtube/channel/manual-claims/sync')
          .then(r => {
              commit('setLoading', false)
              dispatch('readManualClaims')
          })
          .catch(() => {
              commit('setLoading', false)
          })
    },
  }
}
